(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["network-framework"] = factory();
	else
		root["network-framework"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var xhr_client_1 = __webpack_require__(1);
	var shared_entry_1 = __webpack_require__(20);
	/* tslint:enable:no-unused-variable */
	exports.createClient = shared_entry_1.createPreconfiguredClient(xhr_client_1.createXHRClient);
	__export(__webpack_require__(2));
	__export(__webpack_require__(5));
	//# sourceMappingURL=browser-entry.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var errors_1 = __webpack_require__(2);
	var uri_1 = __webpack_require__(5);
	var Observable_1 = __webpack_require__(6);
	function parseResponseHeaders(xhr) {
	    var str = xhr.getAllResponseHeaders();
	    if (typeof str !== 'string') {
	        return [];
	    }
	    str = String(str);
	    if (str.length === 0) {
	        return [];
	    }
	    return str
	        .split('\r\n')
	        .filter(function (header) { return header.trim().length > 0; })
	        .map(function (header) {
	        var index = header.indexOf(':');
	        return [
	            header.slice(0, index).trim().toLowerCase(),
	            header.slice(index + 1).trim(),
	        ];
	    });
	}
	var XHRRequest = (function (_super) {
	    __extends(XHRRequest, _super);
	    function XHRRequest(config) {
	        var _this = this;
	        var uri = uri_1.normalizeURI(config.uri);
	        _super.call(this, function (subscriber) {
	            var replied = false;
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState >= 2) {
	                    replied = true;
	                    subscriber.next(new XHRResponse(_this, xhr));
	                    subscriber.complete();
	                }
	            };
	            xhr.onerror = function (q) {
	                replied = true;
	                subscriber.error(new errors_1.RequestNetworkError('Request Error'));
	            };
	            xhr.open(_this.method, _this.uri.toString(), true);
	            xhr.withCredentials = true;
	            _this.headers.forEach(function (_a) {
	                var name = _a[0], value = _a[1];
	                xhr.setRequestHeader(name, value);
	            });
	            xhr.send(typeof config.body === 'string' ? config.body : null);
	            return function () {
	                if (!replied) {
	                    replied = true;
	                    xhr.abort();
	                }
	            };
	        });
	        this.config = config;
	        this.uri = uri;
	        this.method = config.method || 'GET';
	        this.headers = this.config.headers || [];
	        this.body = this.config.body || '';
	    }
	    return XHRRequest;
	}(Observable_1.Observable));
	exports.XHRRequest = XHRRequest;
	var XHRResponse = (function (_super) {
	    __extends(XHRResponse, _super);
	    function XHRResponse(request, xhr) {
	        var _this = this;
	        var done = false;
	        var listeners = [];
	        var error = undefined;
	        var notify = function (err) {
	            if (done) {
	                return;
	            }
	            done = true;
	            error = err;
	            listeners.forEach(function (listener) { return listener(); });
	            listeners = undefined;
	        };
	        var abort = function (listener) {
	            if (done) {
	                return;
	            }
	            listeners = listeners.filter(function (l) { return l !== listener; });
	            if (listeners.length === 0) {
	                xhr.abort();
	                notify(new errors_1.ResponseNetworkError('Response is aborted'));
	            }
	        };
	        if (typeof xhr.status !== 'number' || xhr.status === 0) {
	            notify(new errors_1.ResponseNetworkError('Response have invalid status code'));
	        }
	        else if (xhr.readyState === 4) {
	            notify();
	        }
	        else {
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState !== 4) {
	                    return;
	                }
	                notify();
	            };
	            xhr.onerror = function () {
	                notify(new errors_1.ResponseNetworkError('Response Error'));
	            };
	        }
	        _super.call(this, function (subscriber) {
	            var replied = false;
	            var reply = function () {
	                replied = true;
	                subscriber.next({
	                    requestConfig: request.config,
	                    requestURI: request.uri,
	                    requestMethod: request.method,
	                    requestHeaders: request.headers,
	                    requestBody: request.body,
	                    responseStatusCode: _this.statusCode,
	                    responseHeaders: _this.headers,
	                    responseBody: xhr.responseText,
	                });
	                subscriber.complete();
	            };
	            if (done) {
	                if (error) {
	                    replied = true;
	                    subscriber.error(error);
	                }
	                else {
	                    reply();
	                }
	            }
	            else {
	                listeners.push(reply);
	            }
	            return function () {
	                if (!replied) {
	                    replied = true;
	                    abort(reply);
	                }
	            };
	        });
	        this.request = request;
	        this.statusCode = typeof xhr.status === 'number' ? xhr.status : 0;
	        this.headers = parseResponseHeaders(xhr);
	    }
	    return XHRResponse;
	}(Observable_1.Observable));
	exports.XHRResponse = XHRResponse;
	var XHRClient = (function () {
	    function XHRClient(config) {
	    }
	    XHRClient.prototype.makeRequest = function (config) {
	        return new XHRRequest(config);
	    };
	    return XHRClient;
	}());
	exports.XHRClient = XHRClient;
	exports.createXHRClient = function (config) { return new XHRClient(config); };
	//# sourceMappingURL=xhr_client.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var makeErrorCause = __webpack_require__(3);
	var NetworkError = (function (_super) {
	    __extends(NetworkError, _super);
	    function NetworkError(message, cause) {
	        _super.call(this, message, cause);
	    }
	    return NetworkError;
	}(makeErrorCause.BaseError));
	exports.NetworkError = NetworkError;
	var TimeoutNetworkError = (function (_super) {
	    __extends(TimeoutNetworkError, _super);
	    function TimeoutNetworkError(message, cause) {
	        _super.call(this, message, cause);
	    }
	    return TimeoutNetworkError;
	}(NetworkError));
	exports.TimeoutNetworkError = TimeoutNetworkError;
	var RequestNetworkError = (function (_super) {
	    __extends(RequestNetworkError, _super);
	    function RequestNetworkError(message, cause) {
	        _super.call(this, message, cause);
	    }
	    return RequestNetworkError;
	}(NetworkError));
	exports.RequestNetworkError = RequestNetworkError;
	var ResponseNetworkError = (function (_super) {
	    __extends(ResponseNetworkError, _super);
	    function ResponseNetworkError(message, cause) {
	        _super.call(this, message, cause);
	    }
	    return ResponseNetworkError;
	}(NetworkError));
	exports.ResponseNetworkError = ResponseNetworkError;
	var BadStatusCodeNetworkError = (function (_super) {
	    __extends(BadStatusCodeNetworkError, _super);
	    function BadStatusCodeNetworkError(statusCode, response) {
	        _super.call(this, "Bad response status code " + statusCode);
	        this.statusCode = statusCode;
	        this.response = response;
	    }
	    return BadStatusCodeNetworkError;
	}(ResponseNetworkError));
	exports.BadStatusCodeNetworkError = BadStatusCodeNetworkError;
	var CircuitBreakerError = (function (_super) {
	    __extends(CircuitBreakerError, _super);
	    function CircuitBreakerError(message, cause) {
	        _super.call(this, message, cause);
	    }
	    return CircuitBreakerError;
	}(NetworkError));
	exports.CircuitBreakerError = CircuitBreakerError;
	//# sourceMappingURL=errors.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var makeError = __webpack_require__(4);
	function makeErrorCause(value, _super) {
	    if (_super === void 0) { _super = makeErrorCause.BaseError; }
	    return makeError(value, _super);
	}
	var makeErrorCause;
	(function (makeErrorCause) {
	    var BaseError = (function (_super) {
	        __extends(BaseError, _super);
	        function BaseError(message, cause) {
	            _super.call(this, message);
	            this.cause = cause;
	        }
	        BaseError.prototype.toString = function () {
	            return _super.prototype.toString.call(this) + (this.cause ? "\nCaused by: " + this.cause.toString() : '');
	        };
	        return BaseError;
	    }(makeError.BaseError));
	    makeErrorCause.BaseError = BaseError;
	})(makeErrorCause || (makeErrorCause = {}));
	module.exports = makeErrorCause;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// ISC @ Julien Fontanet
	
	'use strict'
	
	// ===================================================================
	
	var defineProperty = Object.defineProperty
	
	// -------------------------------------------------------------------
	
	var captureStackTrace = Error.captureStackTrace
	if (!captureStackTrace) {
	  captureStackTrace = function captureStackTrace (error) {
	    var container = new Error()
	
	    defineProperty(error, 'stack', {
	      configurable: true,
	      get: function getStack () {
	        var stack = container.stack
	
	        // Replace property with value for faster future accesses.
	        defineProperty(this, 'stack', {
	          value: stack
	        })
	
	        return stack
	      },
	      set: function setStack (stack) {
	        defineProperty(error, 'stack', {
	          configurable: true,
	          value: stack,
	          writable: true
	        })
	      }
	    })
	  }
	}
	
	// -------------------------------------------------------------------
	
	function BaseError (message) {
	  if (message) {
	    defineProperty(this, 'message', {
	      configurable: true,
	      value: message,
	      writable: true
	    })
	  }
	
	  var cname = this.constructor.name
	  if (
	    cname &&
	    cname !== this.name
	  ) {
	    defineProperty(this, 'name', {
	      configurable: true,
	      value: cname,
	      writable: true
	    })
	  }
	
	  captureStackTrace(this, this.constructor)
	}
	
	BaseError.prototype = Object.create(Error.prototype, {
	  // See: https://github.com/JsCommunity/make-error/issues/4
	  constructor: {
	    configurable: true,
	    value: BaseError,
	    writable: true
	  }
	})
	
	// -------------------------------------------------------------------
	
	// Sets the name of a function if possible (depends of the JS engine).
	var setFunctionName = (function () {
	  function setFunctionName (fn, name) {
	    return defineProperty(fn, 'name', {
	      configurable: true,
	      value: name
	    })
	  }
	  try {
	    var f = function () {}
	    setFunctionName(f, 'foo')
	    if (f.name === 'foo') {
	      return setFunctionName
	    }
	  } catch (_) {}
	})()
	
	// -------------------------------------------------------------------
	
	function makeError (constructor, super_) {
	  if (super_ == null || super_ === Error) {
	    super_ = BaseError
	  } else if (typeof super_ !== 'function') {
	    throw new TypeError('super_ should be a function')
	  }
	
	  var name
	  if (typeof constructor === 'string') {
	    name = constructor
	    constructor = function () { super_.apply(this, arguments) }
	
	    // If the name can be set, do it once and for all.
	    if (setFunctionName) {
	      setFunctionName(constructor, name)
	      name = null
	    }
	  } else if (typeof constructor !== 'function') {
	    throw new TypeError('constructor should be either a string or a function')
	  }
	
	  // Also register the super constructor also as `constructor.super_` just
	  // like Node's `util.inherits()`.
	  constructor.super_ = constructor['super'] = super_
	
	  var properties = {
	    constructor: {
	      configurable: true,
	      value: constructor,
	      writable: true
	    }
	  }
	
	  // If the name could not be set on the constructor, set it on the
	  // prototype.
	  if (name != null) {
	    properties.name = {
	      configurable: true,
	      value: name,
	      writable: true
	    }
	  }
	  constructor.prototype = Object.create(super_.prototype, properties)
	
	  return constructor
	}
	exports = module.exports = makeError
	exports.BaseError = BaseError


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	var URI = (function () {
	    function URI(decl) {
	        this.scheme = decl.scheme || 'http';
	        this.host = decl.host;
	        this.port = decl.port || (decl.scheme === 'https' ? 443 : 80);
	        this.path = decl.path;
	        this.query = decl.query || '';
	    }
	    URI.prototype.toString = function () {
	        return stringifyURI(this);
	    };
	    return URI;
	}());
	exports.URI = URI;
	function normalizeURI(decl) {
	    return new URI(decl);
	}
	exports.normalizeURI = normalizeURI;
	function stringifyURI(uri) {
	    var portIsStandard = (uri.scheme === 'https' && uri.port === 443) || (uri.scheme === 'http' && uri.port === 80);
	    var portFragment = portIsStandard ? '' : ':' + String(uri.port);
	    var hostFragment = uri.host + portFragment;
	    var schemeFragment = uri.scheme + "://";
	    var pathFragment = uri.path === '' ? '/' : uri.path;
	    var searchFragment = uri.query === '' ? '' : '?' + uri.query;
	    return schemeFragment + hostFragment + pathFragment + searchFragment;
	}
	exports.stringifyURI = stringifyURI;
	function invariant(statement, message) {
	    if (!statement) {
	        throw new Error(message);
	    }
	}
	function firstPositive() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    for (var i = 0; i < args.length; i++) {
	        var x = args[i];
	        if (x >= 0) {
	            return x;
	        }
	    }
	    return 0;
	}
	function parseURI(uri) {
	    var processedUri = uri;
	    var schemeEndIndex = uri.indexOf('://');
	    invariant(schemeEndIndex >= 0, 'Unable to parse scheme');
	    var scheme = processedUri.slice(0, schemeEndIndex);
	    processedUri = processedUri.slice(schemeEndIndex + 3);
	    invariant(scheme === 'http' || scheme === 'https', "Unknown scheme '" + scheme + "'");
	    var atIndex = processedUri.indexOf('@');
	    var colonIndex = processedUri.indexOf(':');
	    if (colonIndex >= 0 && colonIndex < atIndex) {
	        var sliceLength = colonIndex + 1;
	        processedUri = processedUri.slice(sliceLength);
	        atIndex -= sliceLength;
	    }
	    colonIndex = processedUri.indexOf(':');
	    if (colonIndex >= 0) {
	        invariant(colonIndex > atIndex, "Invalid uri '" + uri + "'");
	    }
	    var slashIndex = processedUri.indexOf('/');
	    if (slashIndex >= 0) {
	        invariant(slashIndex > atIndex && slashIndex > colonIndex, "Invalid uri '" + uri + "'");
	    }
	    var questionMarkIndex = processedUri.indexOf('?');
	    if (questionMarkIndex >= 0) {
	        invariant(questionMarkIndex > atIndex && questionMarkIndex > colonIndex && questionMarkIndex > slashIndex, "Invalid uri '" + uri + "'");
	    }
	    var hashIndex = processedUri.indexOf('#');
	    if (hashIndex >= 0) {
	        invariant(hashIndex > atIndex && hashIndex > colonIndex && hashIndex > slashIndex && hashIndex > questionMarkIndex, "Invalid uri '" + uri + "'");
	    }
	    if (atIndex >= 0) {
	        var sliceLength = atIndex + 1;
	        processedUri.slice(0, atIndex);
	        processedUri = processedUri.slice(sliceLength);
	        colonIndex -= sliceLength;
	        slashIndex -= sliceLength;
	        questionMarkIndex -= sliceLength;
	        hashIndex -= sliceLength;
	    }
	    var host = '';
	    {
	        var sliceLength = firstPositive(colonIndex, slashIndex, questionMarkIndex, hashIndex, processedUri.length);
	        invariant(sliceLength > 0, "Invalid uri '" + uri + "'");
	        host = processedUri.slice(0, sliceLength);
	        processedUri = processedUri.slice(sliceLength);
	        colonIndex -= sliceLength;
	        slashIndex -= sliceLength;
	        questionMarkIndex -= sliceLength;
	        hashIndex -= sliceLength;
	    }
	    var port = scheme === 'http' ? 80 : 443;
	    if (colonIndex === 0) {
	        var sliceLength = firstPositive(slashIndex, questionMarkIndex, hashIndex, processedUri.length);
	        var stringPort = processedUri.slice(1, sliceLength);
	        port = parseInt(stringPort, 10);
	        invariant(String(port) === stringPort, "Invalid port '" + stringPort + "'");
	        processedUri = processedUri.slice(sliceLength);
	        slashIndex -= sliceLength;
	        questionMarkIndex -= sliceLength;
	        hashIndex -= sliceLength;
	    }
	    var path = '/';
	    {
	        var sliceLength = firstPositive(questionMarkIndex, hashIndex, processedUri.length);
	        if (sliceLength > 0) {
	            path = processedUri.slice(0, sliceLength);
	            processedUri = processedUri.slice(sliceLength);
	            questionMarkIndex -= sliceLength;
	            hashIndex -= sliceLength;
	        }
	    }
	    var query = '';
	    {
	        var sliceLength = firstPositive(hashIndex, processedUri.length);
	        query = processedUri.slice(1, sliceLength);
	    }
	    return {
	        scheme: scheme,
	        host: host,
	        port: port,
	        path: path,
	        query: query,
	    };
	}
	exports.parseURI = parseURI;
	function mergeBaseUriPiece(baseUriPiece, extensionPiece) {
	    if (typeof extensionPiece === 'undefined') {
	        return baseUriPiece;
	    }
	    if (typeof extensionPiece === 'function') {
	        return extensionPiece(baseUriPiece);
	    }
	    return extensionPiece;
	}
	function mergeBaseUri(baseUri, extension) {
	    var parsedBaseUri = parseURI(baseUri);
	    var scheme = mergeBaseUriPiece(parsedBaseUri.scheme, extension.scheme);
	    var host = mergeBaseUriPiece(parsedBaseUri.host, extension.host);
	    var port = mergeBaseUriPiece(parsedBaseUri.port, extension.port);
	    var path = mergeBaseUriPiece(parsedBaseUri.path, extension.path);
	    var query = mergeBaseUriPiece(parsedBaseUri.query, extension.query);
	    return {
	        scheme: scheme,
	        host: host,
	        port: port,
	        path: path,
	        query: query,
	    };
	}
	exports.mergeBaseUri = mergeBaseUri;
	function mergePaths(left, right) {
	    var leftSlash = left[left.length - 1] === '/';
	    var rightSlash = right[0] === '/';
	    if (leftSlash && rightSlash) {
	        return left + right.slice(1);
	    }
	    if (!leftSlash && !rightSlash) {
	        return left + '/' + right;
	    }
	    return left + right;
	}
	exports.mergePaths = mergePaths;
	//# sourceMappingURL=uri.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(7);
	var toSubscriber_1 = __webpack_require__(8);
	var observable_1 = __webpack_require__(19);
	/**
	 * A representation of any set of values over any amount of time. This the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is  called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    /**
	     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
	     *
	     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
	     *
	     * `subscribe` is not a regular operator, but a method that calls Observables internal `subscribe` function. It
	     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
	     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
	     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
	     * thought.
	     *
	     * Apart from starting the execution of an Observable, this method allows you to listen for values
	     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
	     * following ways.
	     *
	     * The first way is creating an object that implements {@link Observer} interface. It should have methods
	     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
	     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
	     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
	     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
	     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
	     * be left uncaught.
	     *
	     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
	     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
	     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
	     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
	     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
	     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
	     *
	     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
	     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
	     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
	     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
	     *
	     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
	     * It is an Observable itself that decides when these functions will be called. For example {@link of}
	     * by default emits all its values synchronously. Always check documentation for how given Observable
	     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
	     *
	     * @example <caption>Subscribe with an Observer</caption>
	     * const sumObserver = {
	     *   sum: 0,
	     *   next(value) {
	     *     console.log('Adding: ' + value);
	     *     this.sum = this.sum + value;
	     *   },
	     *   error() { // We actually could just remote this method,
	     *   },        // since we do not really care about errors right now.
	     *   complete() {
	     *     console.log('Sum equals: ' + this.sum);
	     *   }
	     * };
	     *
	     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
	     * .subscribe(sumObserver);
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Subscribe with functions</caption>
	     * let sum = 0;
	     *
	     * Rx.Observable.of(1, 2, 3)
	     * .subscribe(
	     *   function(value) {
	     *     console.log('Adding: ' + value);
	     *     sum = sum + value;
	     *   },
	     *   undefined,
	     *   function() {
	     *     console.log('Sum equals: ' + sum);
	     *   }
	     * );
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Cancel a subscription</caption>
	     * const subscription = Rx.Observable.interval(1000).subscribe(
	     *   num => console.log(num),
	     *   undefined,
	     *   () => console.log('completed!') // Will not be called, even
	     * );                                // when cancelling subscription
	     *
	     *
	     * setTimeout(() => {
	     *   subscription.unsubscribe();
	     *   console.log('unsubscribed!');
	     * }, 2500);
	     *
	     * // Logs:
	     * // 0 after 1s
	     * // 1 after 2s
	     * // "unsubscribed!" after 2,5s
	     *
	     *
	     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
	     *  Observable.
	     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled.
	     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     * @method subscribe
	     */
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this.source);
	        }
	        else {
	            sink.add(this.source ? this._subscribe(sink) : this._trySubscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.syncErrorThrown = true;
	            sink.syncErrorValue = err;
	            sink.error(err);
	        }
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            // Must be declared in a separate statement to avoid a RefernceError when
	            // accessing subscription below in the closure due to Temporal Dead Zone.
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	//# sourceMappingURL=Observable.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	// CommonJS / Node have global context exposed as "global" variable.
	// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
	// the global "global" var for now.
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof global !== 'undefined' && global;
	var _root = __window || __global || __self;
	exports.root = _root;
	// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
	// This is needed when used with angular/tsickle which inserts a goog.module statement.
	// Wrap in IIFE
	(function () {
	    if (!_root) {
	        throw new Error('RxJS could not find any global context (window, self, global)');
	    }
	})();
	//# sourceMappingURL=root.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subscriber_1 = __webpack_require__(9);
	var rxSubscriber_1 = __webpack_require__(18);
	var Observer_1 = __webpack_require__(17);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer_1.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(10);
	var Subscription_1 = __webpack_require__(11);
	var Observer_1 = __webpack_require__(17);
	var rxSubscriber_1 = __webpack_require__(18);
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    if (destinationOrNext instanceof Subscriber) {
	                        this.destination = destinationOrNext;
	                        this.destination.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        this._parent = null;
	        this._parents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parent = _parent;
	        this._parents = _parents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer_1.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = this.unsubscribe.bind(this);
	            }
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._error) {
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parentSubscriber.syncErrorValue = err;
	                _parentSubscriber.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(12);
	var isObject_1 = __webpack_require__(13);
	var isFunction_1 = __webpack_require__(10);
	var tryCatch_1 = __webpack_require__(14);
	var errorObject_1 = __webpack_require__(15);
	var UnsubscriptionError_1 = __webpack_require__(16);
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        this._parent = null;
	        this._parents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parent = null;
	        this._parents = null;
	        // null out _subscriptions first so any child subscriptions that attempt
	        // to remove themselves from this subscription will noop
	        this._subscriptions = null;
	        var index = -1;
	        var len = _parents ? _parents.length : 0;
	        // if this._parent is null, then so is this._parents, and we
	        // don't have to remove ourselves from any parent subscriptions.
	        while (_parent) {
	            _parent.remove(this);
	            // if this._parents is null or index >= len,
	            // then _parent is set to null, and the loop exits
	            _parent = ++index < len && _parents[index] || null;
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject_1.errorObject) {
	                hasErrors = true;
	                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
	                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            index = -1;
	            len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject_1.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject_1.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var subscription = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        var subscriptions = this._subscriptions || (this._subscriptions = []);
	        subscriptions.push(subscription);
	        subscription._addParent(this);
	        return subscription;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        if (!_parent || _parent === parent) {
	            // If we don't have a parent, or the new parent is the same as the
	            // current parent, then set this._parent to the new parent.
	            this._parent = parent;
	        }
	        else if (!_parents) {
	            // If there's already one parent, but not multiple, allocate an Array to
	            // store the rest of the parent Subscriptions.
	            this._parents = [parent];
	        }
	        else if (_parents.indexOf(parent) === -1) {
	            // Only add the new parent to the _parents list if it's not already there.
	            _parents.push(parent);
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArray.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	exports.isObject = isObject;
	//# sourceMappingURL=isObject.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errorObject_1 = __webpack_require__(15);
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject_1.errorObject.e = e;
	        return errorObject_1.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	exports.tryCatch = tryCatch;
	;
	//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	// typeof any so that it we don't have to cast when comparing a result to the error object
	exports.errorObject = { e: {} };
	//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	exports.UnsubscriptionError = UnsubscriptionError;
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	"use strict";
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	//# sourceMappingURL=Observer.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(7);
	var Symbol = root_1.root.Symbol;
	exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	    Symbol.for('rxSubscriber') : '@@rxSubscriber';
	/**
	 * @deprecated use rxSubscriber instead
	 */
	exports.$$rxSubscriber = exports.rxSubscriber;
	//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(7);
	function getSymbolObservable(context) {
	    var $$observable;
	    var Symbol = context.Symbol;
	    if (typeof Symbol === 'function') {
	        if (Symbol.observable) {
	            $$observable = Symbol.observable;
	        }
	        else {
	            $$observable = Symbol('observable');
	            Symbol.observable = $$observable;
	        }
	    }
	    else {
	        $$observable = '@@observable';
	    }
	    return $$observable;
	}
	exports.getSymbolObservable = getSymbolObservable;
	exports.observable = getSymbolObservable(root_1.root);
	/**
	 * @deprecated use observable instead
	 */
	exports.$$observable = exports.observable;
	//# sourceMappingURL=observable.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bad_status_code_enhancer_1 = __webpack_require__(21);
	var telemetry_enhancer_1 = __webpack_require__(24);
	var timeout_enhancer_1 = __webpack_require__(27);
	// function hashFunction(requestConfig: IHTTPRequestConfig): string {
	//   return [
	//     requestConfig.method,
	//     requestConfig.uri.host,
	//     requestConfig.uri.port,
	//     requestConfig.uri.path,
	//   ].join(':');
	// }
	function createPreconfiguredClient(createClient) {
	    return function (config) {
	        var finalCreateClient = telemetry_enhancer_1.telemetryEnhancer(
	        // circuitBreakerEnhancer(
	        bad_status_code_enhancer_1.badStatusCodeEnhancer(timeout_enhancer_1.timeoutEnhancer(createClient)));
	        return finalCreateClient({
	            timeout: config.timeout,
	            assertStatusCode: config.assertStatusCode || bad_status_code_enhancer_1.defaultAssertStatusCode,
	            // circuitBreaker: {
	            //   failureTreshold: config.circuitBreaker.failureTreshold,
	            //   samplingDuration: config.circuitBreaker.samplingDuration,
	            //   minimumSamples: config.circuitBreaker.minimumSamples,
	            //   openDuration: config.circuitBreaker.openDuration,
	            //   hashFunction: config.circuitBreaker.hashFunction || hashFunction,
	            // },
	            telemetry: {
	                clientName: config.telemetry.clientName,
	                serverName: config.telemetry.serverName,
	                normalizeHost: config.telemetry.normalizeHost,
	                increment: config.telemetry.increment,
	                timer: config.telemetry.timer,
	            },
	        });
	    };
	}
	exports.createPreconfiguredClient = createPreconfiguredClient;
	//# sourceMappingURL=shared_entry.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errors_1 = __webpack_require__(2);
	var request_utils_1 = __webpack_require__(22);
	var map_1 = __webpack_require__(23);
	exports.defaultAssertStatusCode = function (statusCode) {
	    if (statusCode >= 200 && statusCode < 300) {
	        return true;
	    }
	    if (statusCode >= 300 && statusCode < 400) {
	        return true;
	    }
	    return false;
	};
	exports.badStatusCodeEnhancer = function (createClient) {
	    return function (config) {
	        var defaultClientAssert = config.assertStatusCode || exports.defaultAssertStatusCode;
	        var client = createClient(config);
	        return {
	            makeRequest: function (requestConfig) {
	                var requestAssert = requestConfig.assertStatusCode || defaultClientAssert;
	                return request_utils_1.convertObservableToRequestStream(map_1.map.call(client.makeRequest(requestConfig), function (responseStream) {
	                    if (requestAssert(responseStream.statusCode)) {
	                        return responseStream;
	                    }
	                    else {
	                        throw new errors_1.BadStatusCodeNetworkError(responseStream.statusCode, responseStream);
	                    }
	                }), requestConfig);
	            },
	        };
	    };
	};
	//# sourceMappingURL=bad_status_code_enhancer.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var uri_1 = __webpack_require__(5);
	var map_1 = __webpack_require__(23);
	function normalizeRequestConfig(requestConfig) {
	    return {
	        config: requestConfig,
	        uri: uri_1.normalizeURI(requestConfig.uri),
	        method: requestConfig.method || 'GET',
	        headers: requestConfig.headers || [],
	        body: requestConfig.body || '',
	    };
	}
	exports.normalizeRequestConfig = normalizeRequestConfig;
	function convertObservableToRequestStream(observable, requestConfig) {
	    return Object.assign(map_1.map.call(observable, function (responseStream) { return responseStream; }), normalizeRequestConfig(requestConfig));
	}
	exports.convertObservableToRequestStream = convertObservableToRequestStream;
	//# sourceMappingURL=request_utils.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(9);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    if (typeof project !== 'function') {
	        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	    }
	    return this.lift(new MapOperator(project, thisArg));
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	exports.MapOperator = MapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        _super.call(this, destination);
	        this.project = project;
	        this.count = 0;
	        this.thisArg = thisArg || this;
	    }
	    // NOTE: This looks unoptimized, but it's actually purposefully NOT
	    // using try/catch optimizations.
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=map.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errors_1 = __webpack_require__(2);
	var request_utils_1 = __webpack_require__(22);
	var response_utils_1 = __webpack_require__(25);
	var do_1 = __webpack_require__(26);
	var map_1 = __webpack_require__(23);
	function normalize(str) {
	    var result = str.toLowerCase().replace(/\W+/g, '_').replace(/^_+/, '').replace(/_+$/, '');
	    return result === '' ? '_' : result;
	}
	exports.telemetryEnhancer = function (createClient) {
	    return function (config) {
	        var telemetry = config.telemetry;
	        var client = createClient(config);
	        return {
	            makeRequest: function (requestConfig) {
	                var startDate = Date.now();
	                var request = client.makeRequest(requestConfig);
	                var telemetryKey = [
	                    telemetry.clientName,
	                    telemetry.serverName,
	                    'external',
	                    'http',
	                    normalize(telemetry.normalizeHost ? telemetry.normalizeHost(request.uri.host) : request.uri.host),
	                    normalize(request.uri.path),
	                ].join('.');
	                function handleSuccess(result) {
	                    telemetry.timer(telemetryKey, Date.now() - startDate);
	                    telemetry.increment(telemetryKey + ".success");
	                }
	                function handleError(error) {
	                    if (error instanceof errors_1.CircuitBreakerError) {
	                        telemetry.increment(telemetryKey + ".fail.circuit_breaker");
	                    }
	                    else if (error instanceof errors_1.TimeoutNetworkError) {
	                        telemetry.timer(telemetryKey, Date.now() - startDate);
	                        telemetry.increment(telemetryKey + ".fail.timeout");
	                    }
	                    else if (error instanceof errors_1.BadStatusCodeNetworkError) {
	                        telemetry.timer(telemetryKey, Date.now() - startDate);
	                        telemetry.increment(telemetryKey + ".fail.http_error_" + error.statusCode);
	                    }
	                    else {
	                        telemetry.increment(telemetryKey + ".fail.error_" + normalize(error.message));
	                    }
	                }
	                return request_utils_1.convertObservableToRequestStream(do_1._do.call(map_1.map.call(request, function (response) {
	                    return response_utils_1.convertObservableToResponseStream(do_1._do.call(response, handleSuccess, handleError), response);
	                }), function () { }, handleError), requestConfig);
	            },
	        };
	    };
	};
	//# sourceMappingURL=telemetry_enhancer.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(23);
	function convertObservableToResponseStream(observable, data) {
	    return Object.assign(map_1.map.call(observable, function (response) { return response; }), {
	        request: data.request,
	        statusCode: data.statusCode,
	        headers: data.headers,
	    });
	}
	exports.convertObservableToResponseStream = convertObservableToResponseStream;
	//# sourceMappingURL=response_utils.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(9);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @method do
	 * @name do
	 * @owner Observable
	 */
	function _do(nextOrObserver, error, complete) {
	    return this.lift(new DoOperator(nextOrObserver, error, complete));
	}
	exports._do = _do;
	var DoOperator = (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DoSubscriber = (function (_super) {
	    __extends(DoSubscriber, _super);
	    function DoSubscriber(destination, nextOrObserver, error, complete) {
	        _super.call(this, destination);
	        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	        safeSubscriber.syncErrorThrowable = true;
	        this.add(safeSubscriber);
	        this.safeSubscriber = safeSubscriber;
	    }
	    DoSubscriber.prototype._next = function (value) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.next(value);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.next(value);
	        }
	    };
	    DoSubscriber.prototype._error = function (err) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.error(err);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.error(err);
	        }
	    };
	    DoSubscriber.prototype._complete = function () {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.complete();
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return DoSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=do.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errors_1 = __webpack_require__(2);
	var request_utils_1 = __webpack_require__(22);
	var response_utils_1 = __webpack_require__(25);
	var Observable_1 = __webpack_require__(6);
	exports.timeoutEnhancer = function (createClient) {
	    return function (config) {
	        var client = createClient(config);
	        return {
	            makeRequest: function (requestConfig) {
	                return request_utils_1.convertObservableToRequestStream(new Observable_1.Observable(function (requestSubscriber) {
	                    var requestStartTimestamp = Date.now();
	                    var requestTimeout = setTimeout(function () {
	                        requestSubscriber.error(new errors_1.TimeoutNetworkError('Timeout Error'));
	                    }, config.timeout);
	                    var request = client.makeRequest(requestConfig);
	                    var requestSubscription = request.subscribe(function (response) {
	                        requestSubscriber.next(response_utils_1.convertObservableToResponseStream(new Observable_1.Observable(function (responseSubscriber) {
	                            var diff = Date.now() - requestStartTimestamp;
	                            if (diff >= config.timeout) {
	                                responseSubscriber.error(new errors_1.TimeoutNetworkError('Timeout Error'));
	                                return;
	                            }
	                            var responseTimeout = setTimeout(function () {
	                                responseSubscriber.error(new errors_1.TimeoutNetworkError('Timeout Error'));
	                            }, config.timeout - diff);
	                            var responseSubscription = response.subscribe(function (result) {
	                                responseSubscriber.next(result);
	                            }, function (error) {
	                                responseSubscriber.error(error);
	                            }, function () {
	                                responseSubscriber.complete();
	                            });
	                            return function () {
	                                clearTimeout(responseTimeout);
	                                responseSubscription.unsubscribe();
	                            };
	                        }), response));
	                    }, function (error) {
	                        requestSubscriber.error(error);
	                    }, function () {
	                        requestSubscriber.complete();
	                    });
	                    return function () {
	                        clearTimeout(requestTimeout);
	                        requestSubscription.unsubscribe();
	                    };
	                }), requestConfig);
	            },
	        };
	    };
	};
	//# sourceMappingURL=timeout_enhancer.js.map

/***/ })
/******/ ])
});
;
//# sourceMappingURL=network-framework.js.map